import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { SubpageNavbar } from '../components/SubpageNavbar';
export function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Check for image parameter in URL hash
    const hash = window.location.hash;
    if (hash.includes('?image=')) {
      const params = new URLSearchParams(hash.split('?')[1]);
      const imageIndex = params.get('image');
      if (imageIndex !== null) {
        const index = parseInt(imageIndex, 10);
        if (!isNaN(index) && index >= 0 && index < allImages.length) {
          setSelectedImage(index);
        }
      }
    }
  }, []);
  const allImages = [{
    url: 'https://cdn.magicpatterns.com/uploads/9FViNuEXQAEaWy1qFVrn83/y4.png',
    alt: 'Pohled na budovu z ulice'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/cv1wtq2fqZCj6hSXE5Te1E/y5.png',
    alt: 'Detailní pohled na balkony'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/dFfdPhD6t68BCbFttac4wK/y14.png',
    alt: 'Pohled do vnitrobloku'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/bU4SVwPt1E9gMXQ1qLB7h9/yImage2.jpg',
    alt: 'Komerční prostory'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/tKD1itKFawLmmsHs5yW6vU/yImage11.jpg',
    alt: 'Letecký pohled na areál'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/wCY32QXM3JDSp2ZsR1AJCT/Image4.jpg',
    alt: 'Hlavní pohled'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/39KQJnk7h7vyeYhmKC3uMY/1.png',
    alt: 'Pohled na projekt'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/v6gs57YcUP7SjvabVV3GrM/17.png',
    alt: 'Výhled z balkonu'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/i9JpYVUBygdtmsouK5Bfm9/z7.png',
    alt: 'Pohled na budovu se supermarketem'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/mAKpfHh31aToY41zAmjxaj/zImage6.jpg',
    alt: 'Pohled na vnitroblok se zahradami'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/ei9DZQb3zuUXvRSyGBZuwv/zImage7.jpg',
    alt: 'Boční pohled na budovu'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/c1nhjMGUBrbcPFSUx1WNyF/zImage8.jpg',
    alt: 'Přední pohled s trávníkem'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/r8Fu6yRAphTh8NtKhEqqNR/zImage9.png',
    alt: 'Detail vstupu do supermarketu'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/fL7ried4BTueF1bAHDAEue/xx2.png',
    alt: 'Pohled na vstup se supermarketem'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/bwjXJdQQRFAcrtLM73zcm5/xx9.png',
    alt: 'Pohled z ulice na budovu'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/7ztt7Yqqj52gemp6TqH5fd/xxImage4_000.jpg',
    alt: 'Pohled na budovu při západu slunce'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/ib8v62srpxb7XyXED2J4wi/xxImage5.jpg',
    alt: 'Večerní pohled na osvětlenou budovu'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/mhmk9wveqCn4yrBUAr4sWa/xxImage11.png',
    alt: 'Letecký pohled na komplex s parkovištěm'
  }];
  const goToPrevious = () => {
    if (selectedImage !== null) {
      const newIndex = selectedImage === 0 ? allImages.length - 1 : selectedImage - 1;
      setSelectedImage(newIndex);
    }
  };
  const goToNext = () => {
    if (selectedImage !== null) {
      const newIndex = selectedImage === allImages.length - 1 ? 0 : selectedImage + 1;
      setSelectedImage(newIndex);
    }
  };
  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (selectedImage === null) return;
      if (e.key === 'ArrowLeft') {
        goToPrevious();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      } else if (e.key === 'Escape') {
        setSelectedImage(null);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);
  return <div className="min-h-screen bg-base-cream font-body text-base-dark flex flex-col" data-id="element-302" data-mp="r5ui4jye64p6">
      <SubpageNavbar currentPage="galerie" data-id="element-303" data-mp="1evotsy6z5n7u" />

      <main className="flex-grow py-16" data-id="element-304" data-mp="1ewrkp64arpnr">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-305" data-mp="1etvl7dcswsx7">
          <div className="text-center mb-16" data-id="element-306" data-mp="1jthyfmsmq960">
            <h1 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-307" data-mp="1jsf5l9bqxwng">
              Galerie
            </h1>
            <p className="text-base-gray max-w-2xl mx-auto" data-id="element-308" data-mp="1atuyz6jgndfl">
              Prohlédněte si všechny vizualizace a detaily projektu Svatý
              Václav.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-309" data-mp="3vkc2eafcfwp2">
            {allImages.map((img, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index % 3 * 0.1
          }} className="relative group overflow-hidden rounded-xl cursor-pointer aspect-[4/3] shadow-sm hover:shadow-xl transition-shadow" onClick={() => setSelectedImage(index)} data-id="element-310" data-mp="3n2jvmu924dsf" data-mpi={index}>
                <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-311" data-mp="39c6pmxfq795q" />
                <div className="absolute inset-0 bg-primary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-312" data-mp="2go13q7cxre4b">
                  <span className="text-white font-medium tracking-wider uppercase border border-white/50 px-6 py-2 rounded-sm backdrop-blur-sm" data-id="element-313" data-mp="pj7ova7i9mg7">
                    Zvětšit
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-314" data-mp="1l8pmefo31ue" />

      {/* Lightbox */}
      <AnimatePresence data-id="element-315" data-mp="1maeblplvmul">
        {selectedImage !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 md:p-12" onClick={() => setSelectedImage(null)} data-id="element-316" data-mp="6kbsbs86cvz7">
            {/* Close button */}
            <button className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-10" onClick={() => setSelectedImage(null)} aria-label="Zavřít" data-id="element-317" data-mp="1qznlrjt0lqzx">
              <XIcon className="w-8 h-8" data-id="element-318" data-mp="1w626gtvsnibw" />
            </button>

            {/* Previous button */}
            <button className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-colors z-10" onClick={e => {
          e.stopPropagation();
          goToPrevious();
        }} aria-label="Předchozí obrázek" data-id="element-319" data-mp="1rd92w9c2ag1e">
              <ChevronLeftIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-320" data-mp="18fpzpmcabrmw" />
            </button>

            {/* Next button */}
            <button className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-colors z-10" onClick={e => {
          e.stopPropagation();
          goToNext();
        }} aria-label="Další obrázek" data-id="element-321" data-mp="14g7hwzfrfwoa">
              <ChevronRightIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-322" data-mp="38b2g3w34haer" />
            </button>

            {/* Image counter */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-sm z-10" data-id="element-323" data-mp="3d8vn2rc928g3">
              {selectedImage + 1} / {allImages.length}
            </div>

            {/* Image */}
            <motion.img key={selectedImage} initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} src={allImages[selectedImage].url} alt={allImages[selectedImage].alt} className="max-w-full max-h-full object-contain rounded-md shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-324" data-mp="33cslpnp82du7" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}